module.exports = __webpack_public_path__ + "static/media/error404.22973261.svg";